module.exports = __webpack_public_path__ + "static/img/19-0919_2.0b15c20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/19-0919_2.jpg
// module id = WCVd
// module chunks = 0